// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/bass-first-look.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const bassFirstLook: Score = {
  slug: "bass-first-look",
  n: 24,
  title: "First Look Down",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 84,
  staves: 1,
  clefs: ["bass"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 48,
  highest: 55,
  hasLyrics: false,
  jasonNote: "Your left hand gets its own stave now, and its own clef. Look \u2014 this is the same tune as First Steps, note for note. You already know how it goes. All that has changed is where it is written.",
  teaches: ["the bass clef on its own", "left hand alone", "five-finger position on C below middle C"],
  art: "/sight-reading/art/bass-first-look.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/bass-first-look.jpg",
  newForThisEdition: true,
  fillsGap: "THE BIGGEST HOLE: the printed book introduces the bass clef already inside a two-hand grand staff, at piece 10, with no bass-clef-only step.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 48, pitch: "C3", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 55, pitch: "G3", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 48, pitch: "C3", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
  ],
};
